(function () {
    var chatHasEnded = false;
    
    function escapeBasicHtml(text) {
        if (text == null) return '';
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function sanitizeUrl(url) {
        try {
            var trimmed = String(url || '').trim();
            if (/^(https?:|mailto:|tel:)/i.test(trimmed)) {
                return trimmed.replace(/"/g, '%22');
            }
        } catch (e) { /* noop */ }
        return '#';
    }
    
    function validateOutput(jsonString, fallback) {
        try {
            return JSON.parse(jsonString);
        } catch (e) {
            return fallback;
        }
    }
    
    function handleButtonState(button, isLoading) {
        var buttonText = button.find('.button-text');
        var loadingSpinner = button.find('.loading-spinner');
        
        if (isLoading) {
            button.prop('disabled', true);
            buttonText.fadeOut(200, function() {
                loadingSpinner.fadeIn(200);
            });
        } else {
            loadingSpinner.fadeOut(200, function() {
                buttonText.fadeIn(200);
            });
            button.prop('disabled', false);
        }
    }
    
    function submitContactForm() {
        $('#form-faq-contact').submit();
    }

    function initializeChat() {
        var chatInput = $('#chat-input');
        var chatSendBtn = $('#chat-send-btn');

        function sendMessage(){
            if (chatHasEnded) return;
            var message = chatInput.val().trim();
            if (message === '') return;
        
            chatInput.prop('disabled', true);
            chatSendBtn.prop('disabled', true);
            
            addChatMessage(message, true);
            chatInput.val('');
            
            sendMessageApi(message, function(response) {
                chatInput.prop('disabled', false);
                chatSendBtn.prop('disabled', false);
                chatInput.focus();
                
                if (response && response.success) {
                    var output = validateOutput(response.response, null);
                    if (output && output[0] && output[0].output === 'TRANSFER') {
                        addChatMessage('Vou criar um protocolo para acompanhar seu caso. Em breve você receberá um e-mail com as informações do seu atendimento.', false);
                        setTimeout(function() {
                            addChatMessage('O chat foi finalizado. Obrigado pelo contato!', false);
                            $('.chat-input-container').hide();
                            chatHasEnded = true;
                        }, 1500);
                        setTimeout(submitContactForm, 3500);
                    } else if (output && output[0] && output[0].output) {
                        addChatMessage(output[0].output, false);
                    } else {
                        addChatMessage('Desculpe, não consegui processar sua mensagem.', false);
                    }
                } else {
                    addChatMessage('Desculpe, não consegui processar sua mensagem.', false);
                }
            }, function(errorMsg) {
                chatInput.prop('disabled', false);
                chatSendBtn.prop('disabled', false);
                chatInput.focus();
                addChatMessage(errorMsg, false);
            });
        }
        
        chatSendBtn.click(sendMessage);
        
        chatInput.keyup(function(e) {
            if (e.which === 13) { // Enter key
                e.preventDefault();
                sendMessage();
            }
        });
        
        $('.mini-chat-support').on('shown', function() {
            chatInput.focus();
        });
    }
    
    function formatMarkdownMessage(text) {
        text = escapeBasicHtml(text);
        text = text.replace(/^### (.*)$/gm, '<h3>$1</h3>');
        text = text.replace(/^## (.*)$/gm, '<h2>$1</h2>');
        text = text.replace(/^# (.*)$/gm, '<h1>$1</h1>');
        text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(_, label, url) {
            return '<a href="' + sanitizeUrl(url) + '" target="_blank" rel="noopener noreferrer nofollow">' + label + '</a>';
        });
        text = text.replace(/\*\*(?!\s)([^*]+?)\*\*/g, '<strong>$1</strong>');
        text = text.replace(/__(?!\s)([^_]+?)__/g, '<strong>$1</strong>');
        text = text.replace(/\B\*(?!\s)([^*]+?)\*\B/g, '<em>$1</em>');
        text = text.replace(/\B_(?!\s)([^_]+?)_\B/g, '<em>$1</em>');
        text = text.replace(/\n/g, '<br>');
        return text;
    }
    
    function typeHtmlSafely(messageId, htmlContent, delay) {
        const $target = $('#' + messageId + ' .message-content p');
        const $wrapper = $('<div>').html(htmlContent);
        const nodes = $wrapper.contents().toArray();
        const state = { 'i': 0 };
        function typeNode() {
            if (state['i'] >= nodes.length) return;
            const current = nodes[state['i']++];
            const isText = current.nodeType === Node.TEXT_NODE;
    
            if (isText) {
                const text = current.nodeValue;
                const localState = { 'j': 0 };
    
                (function typeChar() {
                    if (localState['j'] < text.length) {
                        $target.append(document.createTextNode(text.charAt(localState['j']++)));
                        setTimeout(typeChar, delay);
                    } else {
                        typeNode();
                    }
                })();
    
            } else {
                $target.append(current);
                typeNode();
            }
        }
    
        typeNode();
    }
    
    function addChatMessage(message, isUser) {
        var chatMessages = $('#chat-messages');
        if (chatMessages.length === 0) {
            setTimeout(function() { addChatMessage(message, isUser); }, 100);
            return;
        }
        var currentTime = new Date().toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'});
        if (!isUser) {
            var messageId = 'msg-' + Date.now() + '-' + Math.floor(Math.random()*10000);
            var messageHtml = '<div id="' + messageId + '" class="ai-message bot-message"><div class="message-content"><p></p><span class="message-time">' + currentTime + '</span></div></div>';
            chatMessages.append(messageHtml);
            chatMessages.scrollTop(chatMessages[0].scrollHeight);
            var formattedMessage = formatMarkdownMessage(message);
            typeHtmlSafely(messageId, formattedMessage, 5);
        } else {
            var formattedMessage = escapeBasicHtml(message).replace(/\n/g, '<br>');
            var messageHtml = '<div class="ai-message user-message"><div class="message-content"><p>' + formattedMessage + '</p><span class="message-time">' + currentTime + '</span></div></div>';
            chatMessages.append(messageHtml);
            chatMessages.scrollTop(chatMessages[0].scrollHeight);
        }
    }
    
    function sendMessageApi(message, onSuccess, onError) {
        var tempId = 'temp-pensando-msg';
        var formData = new FormData();
        formData.append('message', message);
        formData.append('YII_CSRF_TOKEN', $('[name="YII_CSRF_TOKEN"]').val());
        
        $.ajax({
            url: '/cms/faq/sendmessage/',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function(xhr) {
                setTimeout(function() {
                    var tempMessageHtml = '<div id="' + tempId + '" class="ai-message bot-message"><div class="message-content"><p><em>Escrevendo...</em></p><span class="message-time">' + new Date().toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'}) + '</span></div></div>';
                    $('#chat-messages').append(tempMessageHtml);
                    $('#chat-messages').scrollTop($('#chat-messages')[0].scrollHeight);
                }, 1000);
            },
            success: function(data) {
                var response = data;
                if (typeof data === 'string') {
                    try {
                        response = JSON.parse(data);
                    } catch (e) {
                        if (onError) onError('Erro ao processar a resposta.');
                        return;
                    }
                }
                $('#' + tempId).remove();
                if (onSuccess) onSuccess(response);
            },
            error: function(xhr, status, error) {
                $('#' + tempId).remove();
                if (onError) onError('Erro de conexão. Tente novamente.');
            }
        });
    }
    
    function interceptContact(userMessage, fullMessage) {
        var button = $("#agent-validate-button");
        
        sendMessageApi(fullMessage, function(response) {
            handleButtonState(button, false);
            
            if (response && response.success) {
                var output = validateOutput(response.response, null);
                if (output && output[0] && output[0].output && output[0].output !== 'TRANSFER') {
                    $('.smart-email .mainContent .container').fadeOut(500, function() {
                        $('.mini-chat-support').fadeIn(500, function() {
                            initializeChat();

                            setTimeout(function() {
                                addChatMessage(userMessage, true);
                            }, 100);
                            
                            setTimeout(function() {
                                addChatMessage(output[0].output, false);
                            }, 600);
                        });
                    });
                } else {
                    submitContactForm();
                }    
            } else {
                submitContactForm();
            }
        }, function(errorMsg) {
            handleButtonState(button, false);
            submitContactForm();
        });
    }
    
    window.interceptContact = interceptContact;
})();